const getMatrixDimensions = (noun, bonuses = [], keyIdentifier = "make") => {
	const matrixDimensions = new Map();
	bonuses.forEach((bonus) => {
		const key = bonus?.[keyIdentifier];
		matrixDimensions.set(key, getExactMatrixDimensions(noun, bonus?.tiers));
	});
	return matrixDimensions;
};

const getExactMatrixDimensions = (noun, tiers = []) => {
	const columnsCount = tiers?.[0]?.[noun]?.length || 0;
	const tiersCount = tiers?.length || 0;
	return {
		columns: columnsCount,
		tiers: tiersCount,
	};
};

const getSmallestBonusMatrixDimensions = (bonuses = []) => {
	let smallestColumnsAmount = 10000;
	let smallestTiersAmount = 10000;
	let largestColumnsAmount = 0;
	let largestTiersAmount = 0;

	bonuses.forEach((bonus) => {
		smallestTiersAmount = Math.min(smallestTiersAmount, bonus?.tiers?.length);
		smallestColumnsAmount = Math.min(smallestColumnsAmount, bonus?.tiers?.[0]?.bonuses?.length);
		largestTiersAmount = Math.max(largestTiersAmount, bonus?.tiers?.length);
		largestColumnsAmount = Math.max(largestColumnsAmount, bonus?.tiers?.[0]?.bonuses?.length);
	});

	return {
		minTiers: smallestTiersAmount,
		minColumns: smallestColumnsAmount,
		maxTiers: largestTiersAmount,
		maxColumns: largestColumnsAmount,
	};
};

export { getMatrixDimensions, getExactMatrixDimensions, getSmallestBonusMatrixDimensions };
